<div class="box-eventos" *ngIf="resumenEventos != null">
    <div class="box-eventos__item"><img src="/assets/img/sura-icon-viajes.svg" alt="SURA ICON VIAJES" />
        <h4 id="numeroViajes">{{resumenEventos.travelCount}}<strong>VIAJES</strong></h4>
    </div>
    <div class="box-eventos__item"><img src="/assets/img/sura-icon-carretera.svg" alt="SURA ICON KMS" />
        <h4 id="numKM" *ngIf="resumenEventos.distanceCount>0">{{resumenEventos.distanceCount |number:'.2'}}<strong>{{resumenEventos.distanceLabel}}</strong></h4>
        <h4 id="numKM" *ngIf="resumenEventos.distanceCount==0">{{resumenEventos.distanceCount}}<strong>{{resumenEventos.distanceLabel}}</strong></h4>
    </div>
    <div class="box-eventos__item"><img src="/assets/img/sura-icon-horas.svg" alt="SURA ICON HORAS" />
        <h4 id="numKM">{{resumenEventos.timeCount}}<strong>{{resumenEventos.timeLabel}}</strong></h4>
    </div>
    <div class="box-eventos__item"><img src="/assets/img/sura-icon-eventos.svg" alt="SURA ICON EVENTOS" />
        <h4 id="numKM">{{resumenEventos.eventCount}}<strong>EVENTOS</strong></h4>
    </div>
</div>
